import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ADDITIONAL_TEXT_PATH, WIDGET_SELECTION_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";
import { notBlank } from "../../shared/validations";
import { Tab } from "@own-local/ad-unit/lib/AdUnit";

const EMAIL_SPELL_NAME = "email";

const FillOrigamiStepProps = {
  previous: ADDITIONAL_TEXT_PATH,
  next: WIDGET_SELECTION_PATH,
  question: "What's your business' <%= target %> address",
  target: "email",
  description: "This is to send you leads to you get from your ad.",
  spellName: EMAIL_SPELL_NAME,
  placeholder: "youremail@example.com",
  validation: notBlank,
  selectedTab: Tab.Contact,
};

export const EmailStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(EmailStep);
